import { render, staticRenderFns } from "./arrange-square-2.vue?vue&type=template&id=501f4d33&"
import script from "./arrange-square-2.vue?vue&type=script&lang=js&"
export * from "./arrange-square-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('501f4d33')) {
      api.createRecord('501f4d33', component.options)
    } else {
      api.reload('501f4d33', component.options)
    }
    module.hot.accept("./arrange-square-2.vue?vue&type=template&id=501f4d33&", function () {
      api.rerender('501f4d33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/arrange-square-2.vue"
export default component.exports